module.exports = __webpack_public_path__ + "img/swire_shipping_logo.f5d1b028.png";